<template>
	<footer class="footer">
		<div class="footer-container" v-show="animate">
			<p class="special" v-if="$route.name === 'Index'">Специальный проект</p>
			<socials></socials>
		</div>
	</footer>
</template>

<script>
	import Socials from '@/components/common/Socials'

	export default {
		name: 'Footer',
		components: {
			Socials
		},
		computed: {
			animate() {
				return this.$store.getters['GET_UI_SHOW'];
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Footer.vue?3f379b6e